module.exports = __webpack_public_path__ + "img/59b7ae3.png";